"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingModule = void 0;
const React = require("react");
const billing_list_1 = require("./modules/billing-list");
const floating_page_1 = require("client/components/page/floating-page");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const router_1 = require("client/components/router");
const mobx_react_1 = require("mobx-react");
const store_1 = require("client/modules/users/store");
// import { LedgerList } from "./modules/ledger-list";
let BillingModule = class BillingModule extends router_1.TabRouter {
    // constructor (props: {}) {
    //   super(props);
    //   this.addRoute("billing", /^\/billing\/?$/, BillingList);
    // }
    constructor(props) {
        super(props);
        this.withPadding = true;
        this.addTab("Billing Statements", `/billing`, /^\/billing\/?$/, billing_list_1.BillingList);
        this.addRoute("/billing", /^\/billing\/(\d+)/, billing_list_1.BillingList);
    }
    render() {
        this.withPadding = true;
        return (React.createElement("div", { className: "asset-approvals" }, store_1.usersStore.permissions.ReadBilling ? (React.createElement(React.Fragment, null,
            React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                React.createElement(kpi_title_1.KpiTitle, { label: "Billing" })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement("div", { className: "inventory-detail__tabs" }, super.render())))) : (store_1.usersStore.showLock())));
    }
};
BillingModule = __decorate([
    mobx_react_1.observer
], BillingModule);
exports.BillingModule = BillingModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/billing/billing.tsx
// module id = 3279
// module chunks = 0